// tslint:disable:max-line-length
import { Injectable } from '@angular/core';
import { USER_AGENTS } from './user-agents';

@Injectable()
export class UtilService {
  constructor() {}

  getDeviceType(): 'desktop' | 'tablet' | 'mobile' {
    return USER_AGENTS.getCurrentDevice();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/shared/util.service.ts